/**
 * A number an entity actually reported, or `null` when it reported none.
 *
 * Geotab fields arrive as plain numbers with no "absent" state of their own, and a `NaN` or an
 * `undefined` read as a number turns into a figure on screen. Sitting between the entity and
 * anything that displays or sums it keeps a missing value missing.
 *
 * @param value - The value as it came off the entity.
 */
export function reportedNumber(value: number | undefined | null): number | null {
  return typeof value === "number" && Number.isFinite(value) ? value : null;
}
